<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-title"><a id="page_3"></a><b>acknowledgments</b></p>
<p class="noindent-f">Thank you to everyone at C&amp;T Publishing.</p>
<p class="noindentt-f"><span class="vio"><b><i>Special thanks to:</i></b></span></p>
<p class="noindentt-f">Helen Frost, my technical editor. Helen and I have worked on nearly all of my books, and I have come to consider her not only a friend but the best technical editor ever.</p>
<p class="noindentt-f">Diane Minkley of Patched Works, Inc. Diane has been the longarm quilter on most of my books. I truly appreciate all you do.</p>
<p class="noindentt-f">My daughter, Ali May. You rock at “name that quilt.”</p>
<p class="noindentt-f">My husband, Gary. He has typed all my books and over the years has become a very good pre-editor in his own right. Thanks, hon.</p>
<p class="image"><img alt="" src="images/pg3_1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Acknowledgments.vue?7ac446d2